import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.for-each";

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable no-restricted-syntax */
import { Parser } from 'acorn';
import acornJsx from 'acorn-jsx';
import MagicString from 'magic-string';
var parser = Parser.extend(acornJsx());

var isNode = function isNode(n) {
  return n !== null && typeof n.type === 'string';
};

function walk(ctx, visitors, node, parent) {
  if (!node) return;
  var visitor = visitors[node.type];
  visitor === null || visitor === void 0 ? void 0 : visitor.forEach(function (v) {
    var _v$enter;

    return (_v$enter = v.enter) === null || _v$enter === void 0 ? void 0 : _v$enter.call(ctx, node, parent);
  }); // eslint-disable-next-line guard-for-in

  for (var key in node) {
    var value = node[key];

    if (isNode(value)) {
      walk(ctx, visitors, value, node);
    }

    if (Array.isArray(value)) {
      var _iterator = _createForOfIteratorHelper(value),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (isNode(item)) {
            walk(ctx, visitors, item, node);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  visitor === null || visitor === void 0 ? void 0 : visitor.forEach(function (v) {
    var _v$leave;

    return (_v$leave = v.leave) === null || _v$leave === void 0 ? void 0 : _v$leave.call(ctx, node, parent);
  });
}

var mergeVisitors = function mergeVisitors(visitors) {
  var rootVisitor = {};

  var _iterator2 = _createForOfIteratorHelper(visitors),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var visitor = _step2.value;

      for (var _i = 0, _Object$keys = Object.keys(visitor); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var value = visitor[key];

        var _iterator3 = _createForOfIteratorHelper(key.split('|')),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var type = _step3.value;
            var normalized = typeof value === 'function' ? {
              enter: value
            } : value;
            rootVisitor[type] = rootVisitor[type] || [];
            rootVisitor[type].push(normalized);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return rootVisitor;
};

export function transform(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    plugins: []
  };
  var plugins = options.plugins;
  var code = new MagicString(source);
  var ast = parser.parse(source, {
    ecmaVersion: 10,
    preserveParens: true,
    sourceType: 'module',
    allowAwaitOutsideFunction: true,
    allowReturnOutsideFunction: true,
    allowHashBang: true,
    onComment: function onComment() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      plugins.forEach(function (p) {
        var _p$onComment2;

        var _p$onComment;

        return (_p$onComment = p.onComment) === null || _p$onComment === void 0 ? void 0 : (_p$onComment2 = _p$onComment).call.apply(_p$onComment2, [p].concat(args));
      });
    }
  });
  walk(code, mergeVisitors(plugins.map(function (p) {
    return p.visitor;
  }).filter(Boolean)), ast);
  return {
    ast: ast,
    code: code.toString(),
    map: code.generateMap({
      file: options.file,
      source: options.source,
      includeContent: options.includeContent !== false
    })
  };
}